<template>
  <div id="app" class="container">

    <div class="row">
      <div class="col-12">

        <div class="mt-5 mb-5" v-bind:class="{ 'text-center': image_align == 'center', 'text-right': image_align == 'right' }">
          <img :src="require(`@/assets/logo_${image_name}.png`)"/>
        </div>

        <router-view class="home"></router-view>

      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'App',
    data () {
      return {
        image_name: process.env.VUE_APP_IMAGE,
        image_align: process.env.VUE_APP_IMAGE_ALIGN
      }
    },
  }
</script>
<style>
  body {
    background-color:#EEE;
  }
  .home {
    background-color:#FFF;
    border-radius: 10px;
    box-shadow: 2px 2px 3px 3px #ccc;
  }
</style>
